import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/PacL.jpg';
import '../CSS/Header.css';

const Header = () => {
  const [hideHeader, setHideHeader] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setHideHeader(currentScrollY > lastScrollY && currentScrollY > 100);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={`header ${hideHeader ? 'header--hidden' : ''}`}>
      <div className="header-container">
        <Link to="/" className="header-logo">
          <img src={logo} alt="MuscleCrete - PAC Corporation" className="logo" />
          <span className="logo-text">MuscleCrete</span>
        </Link>

        <button
          className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${mobileMenuOpen ? 'nav--open' : ''}`}>
          <Link to="/" className="nav-link" onClick={handleNavClick}>Home</Link>
          <Link to="/why-choose-us" className="nav-link" onClick={handleNavClick}>Why Us</Link>
          <Link to="/products" className="nav-link" onClick={handleNavClick}>Products</Link>
          <Link to="/pricing" className="nav-link" onClick={handleNavClick}>Pricing</Link>
          <Link to="/portfolio" className="nav-link" onClick={handleNavClick}>Portfolio</Link>
          <Link to="/faq" className="nav-link" onClick={handleNavClick}>FAQ</Link>
          <Link to="/contact" className="nav-link nav-link--cta" onClick={handleNavClick}>Contact</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
